import React from 'react';
import styled, { css } from 'styled-components';
import { useRouter } from 'next/router';

import { ContentContainerSmall } from '@/components/ContentContainer';
import { useTypedSelector } from '@/store/store';
import { selectSinglePost } from '@/store/reducers/single-post';
import PostCard from '@/components/PostCard';
import { media } from '@/utils/mixin';

import { MORE_POSTS_TITLE_NAMES } from './MorePosts.helpers';

function MorePosts() {
  const page = useTypedSelector(selectSinglePost);
  const parentRoute = useRouter().asPath.split('/')[1];

  if (!page || !page.relatedPosts.length) {
    return null;
  }

  return (
    <Component>
      <ContentContainerSmall>
        <Title>
          {(parentRoute === Object.keys(MORE_POSTS_TITLE_NAMES)[0] &&
            MORE_POSTS_TITLE_NAMES.reviews) ||
            (parentRoute === Object.keys(MORE_POSTS_TITLE_NAMES)[1] &&
              MORE_POSTS_TITLE_NAMES.news) ||
            (parentRoute === Object.keys(MORE_POSTS_TITLE_NAMES)[2] &&
              MORE_POSTS_TITLE_NAMES.offers) ||
            MORE_POSTS_TITLE_NAMES.default}
        </Title>

        <PostsList>
          {page.relatedPosts.map(({ url, title, image }, index) => (
            <PostCard
              key={index}
              title={title ?? ''}
              url={url ?? ''}
              image={image}
            />
          ))}
        </PostsList>
      </ContentContainerSmall>
    </Component>
  );
}

export default MorePosts;

const Component = styled.section`
  padding: 110px 0 60px;
  margin-top: -80px;
  background: ${(props) => props.theme.gray};

  ${media.tablet(css`
    padding: 100px 0 40px;
    margin-top: -70px;
  `)}

  ${media.mobile(css`
    padding: 20px 0 40px;
    margin-top: 0;
    background: ${(props) => props.theme.white};
  `)}

  ${ContentContainerSmall} {
    ${media.tablet(css`
      padding: 0 20px;
    `)}
  }
`;

const Title = styled.span`
  font-weight: 700;
  font-size: 40px;
  line-height: 52px;
  color: ${(props) => props.theme.black};

  ${media.tablet(css`
    font-size: 28px;
    line-height: 36px;
  `)}

  ${media.mobile(css`
    font-size: 24px;
    line-height: 32px;
  `)}
`;

const PostsList = styled.div`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 30px;
  margin-top: 60px;

  ${media.tablet(css`
    margin-top: 40px;
  `)}

  ${media.mobile(css`
    grid-template-columns: repeat(1, 1fr);
  `)}
`;
